import { Injectable } from '@angular/core';
import {
  DscrSummaryResponse,
  LoanProductDscrSummary,
  YearlyDscrSummary
} from '@app/app/interfaces/tax-data/dscr-data-summary.struct';
import { TaxDataService } from '@app/app/services/dscr/tax-data.service';
import { GetDscrData } from '@app/app/store/dscr/dscr.state.actions';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { catchError, tap } from 'rxjs/operators';

interface DscrStateModel {
  dscrByProduct: LoanProductDscrSummary[];
  globalDscrSummary: YearlyDscrSummary[];
  loading: boolean;
}

@State<DscrStateModel>({
  name: 'Dscr',
  defaults: {
    loading: false,
    dscrByProduct: [],
    globalDscrSummary: [],
  }
})
@Injectable({
  providedIn: 'root',
})
export class DscrState {

  @Selector()
  static dscrByProduct(state: DscrStateModel) {
    return state.dscrByProduct;
  }

  @Selector()
  static globalDscrSummary(state: DscrStateModel) {
    return state.globalDscrSummary;
  }

  constructor(
    private taxDataService: TaxDataService,
  ) {}

  @Action(GetDscrData)
  GetDscrResults(
    ctx: StateContext<DscrStateModel>,
    { borrowerId }: GetDscrData,
  ) {
    ctx.patchState({loading: true});

    return this.taxDataService.getDscrDataSummary(borrowerId)
      .pipe(
        catchError(err => {
          ctx.patchState({loading: false});
          throw err;
        }),
        tap(response => {
          const data = response.data as DscrSummaryResponse;
          const { dscrByProduct, globalDscrSummary } = data;
          ctx.setState(patch({
            loading: false,
            dscrByProduct,
            globalDscrSummary,
          }));
        }),
      )
  }
}
